import { provideAppInitializer } from '@angular/core'

import { Bugfender } from '@bugfender/sdk'

import { environment } from '@env'

export const bugfenderInitializer = provideAppInitializer(() => {
	Bugfender.init({
		appKey: environment.logging.loggingConfig.appKey,
		version: '1.0.0',
		build: '1',
		logUIEvents: false,
	})
})
